import React from "react";
import { CssBaseline, Grid } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Navbar from "../Navbar";
import {
  Banner,
  ActivitiesEvents,
  Resources,
  WatchListen,
  Gallery,
  MemberJoinUs,
  GetInvolved,
  Footer,
} from "./sections";

const theme = createTheme();
function HomePage() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <Banner />
      <Grid>
        <ActivitiesEvents />
        <WatchListen />
        <Resources />
        <Gallery />
        <MemberJoinUs />
        <GetInvolved />
        <Footer />
      </Grid>
    </ThemeProvider>
  );
}

export default HomePage;
